import React from 'react'
import ReactDOM from 'react-dom'

import i18n from '../../core/services/i18n/i18n'

import { FeatureTogglesProvider } from '../../core/state/context/featureToggles'

import InlineSearch from '../../components/search/inline/inline'
import Notification from '../../components/notification/notification'
import AdLoader502 from '../../components/ad-loader/ad-loader-502'
import VideoGallery from '../../components/video-gallery/video-gallery'
import videoGalleryDefaults from '../../components/video-gallery/video-gallery.defaults'

const adLoader502Element = document.getElementById('ad-loader-502')
const videoGalleryElement = document.getElementById('video')

if (adLoader502Element) {
  const socialChannels = JSON.parse(adLoader502Element.dataset.socialChannels)

  ReactDOM.render(
    <AdLoader502 social={{ channels: socialChannels }} />,
    adLoader502Element
  )
}

ReactDOM.render(
  <FeatureTogglesProvider>
    <InlineSearch />
  </FeatureTogglesProvider>,
  document.getElementById('inlinesearch')
)

if (location.search.indexOf('accountDeleted') > -1) {
  ReactDOM.render(
    <Notification shown>
      <React.Fragment>
        <p className="notification__title">
          {i18n.get('Account.DeletedNotificationTitle')}
        </p>
        <p className="notification__subtitle">
          {i18n.get('Account.DeletedNotificationSubTitle')}{' '}
          <a className="notification__link" href="/register">
            {i18n.get('Login.RegisterButton')}
          </a>
        </p>
      </React.Fragment>
    </Notification>,
    document.getElementById('notification')
  )
}

if (location.search.indexOf('unsubscribed') > -1) {
  ReactDOM.render(
    <Notification shown>
      <React.Fragment>
        <p className="notification__title">
          {i18n.get('MemberUnsubscribe.NotificationTitle')}
        </p>
        <p className="notification__subtitle">
          {i18n.get('MemberUnsubscribe.NotificationSubtitle')}
        </p>
      </React.Fragment>
    </Notification>,
    document.getElementById('notification')
  )
}

if (videoGalleryElement) {
  ReactDOM.render(
    <VideoGallery videos={videoGalleryDefaults.videos} hasSidebar />,
    videoGalleryElement
  )
}
